export default __webpack_public_path__ + "static/media/nucor.0fd03024.svg";